import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { getOverrides, useClasses } from '../../../utils/overrides';
import Text from '../../typography/Text';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles, 'TitleDivider');
const TitleDivider = _ref => {
  let {
    classes: classesProp,
    overrides: overridesProp,
    className: classNameProp,
    type = 'subtitle',
    children,
    ...props
  } = _ref;
  const classes = useClasses(useStyles, classesProp);
  const override = getOverrides(overridesProp, TitleDivider.overrides);
  const rootProps = useMemo(() => ({
    ...props,
    className: classNames(classes.root, classNameProp)
  }), [classNameProp, classes.root, props]);
  return /*#__PURE__*/React.createElement("div", _extends({}, rootProps, override.root), /*#__PURE__*/React.createElement(Text, _extends({
    type: type,
    className: classes.text
  }, override.Text), children));
};
TitleDivider.overrides = ['root', 'Text'];
process.env.NODE_ENV !== "production" ? TitleDivider.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle', 'body1', 'body', 'button', 'caption', 'captionMedium', 'badges', 'overline'])
} : void 0;
export default /*#__PURE__*/memo(TitleDivider);